import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Container, Form, Spinner } from 'react-bootstrap';
import TrademarkStep1 from './TrademarkStep1';
import TrademarkStep2 from './TrademarkStep2';
import TrademarkStep3 from './TrademarkStep3';
import TrademarkStep4 from './TrademarkStep4';
import TrademarkStep6 from './TrademarkStep6';
import {
  clearErrorMessage,
  trademarkRegistrationPreOrder,
} from '../../redux/actions/productActions';
import { useDispatch, useSelector } from 'react-redux';
import { getUA, isMobile } from 'react-device-detect';
import ProductStep from '../product/ProductStep';
import ProductHeader from '../product/ProductHeader';
import { useCallback, useEffect } from 'react';
import { usePrevious } from '../../hooks';
import Error from '../Error';
import { config } from '_config';
import TrademarkStep43 from './TrademarkStep43';

export default function TrademarkRegistration({
  state,
  onChange,
  onBlur,
  onStep,
  imageLogo,
  imageLogoSrc,
  registerTrademarkList,
  trademarkRushProcessing,
  onHandleCategories,
  onHandleCoOwners,
  steps,
  searchProductList,
  allowedExtensions,
}) {
  const handleChange = useCallback(
    (e) => {
      onChange && onChange(e);
      if (e && e.target && e.target.name && e.target.name === 'option') {
        state.option = e.target.value;
        state.searchType =
          e.target.value === 'BASIC'
            ? 'TRADEMARK_Trademark_Search_Basic'
            : 'TRADEMARK_Trademark_Search_Federal_State';
        handleNext();
      }
    },
    [onChange]
  );

  const [validated, setValidated] = React.useState(false);
  const [suspendedAction, setSuspendedAction] = React.useState(false);

  const errors = useSelector((state) => state.products.error);

  const prevState = usePrevious(state);

  const handleNext = useCallback(() => {
    if (state.verifying) {
      return;
    }

    setSuspendedAction(false);

    localStorage.setItem('product', JSON.stringify(state));
    localStorage.setItem('path', 'trademark-registration');

    setValidated(true);

    const section1 = document.querySelector('.is-invalid');
    if (section1 != null) {
      section1.scrollIntoView();
    } else {
      let form = document.querySelector('#TrademarkForm');
      if (form.checkValidity() === false) {
        document.querySelector('#TrademarkForm').classList.add('was-validated');
        let section = document.querySelector('.form-control:invalid');
        if (section) {
          section.scrollIntoView();
        } else {
          section = document.querySelector('.form-check-input:invalid');
          section.scrollIntoView();
        }
      } else {
        setValidated(false);
        if (state.step === steps.length - 1) {
          preHandleSubmit();
          return;
        } else {
          preHandleSubmit();
          onStep && onStep(state.step + 1);
        }
      }
    }
  }, [state, onStep, preHandleSubmit]);

  const handleBack = useCallback(() => {
    onStep(state.step - 1);
  }, [state, onStep]);

  const handleReset = useCallback(() => {
    onStep(0);
  }, [onStep]);

  const dispatch = useDispatch();
  const [submitted, setSubmitted] = React.useState(false);
  function preHandleSubmit() {
    dispatch(clearErrorMessage());
    const productInfo = {
      ...state,
      device: isMobile && !getUA.includes('Intel') ? 'MOBILE' : 'DESKTOP',
      registerTrademarkType: 'TRADEMARK_RegisterTrademark',
    };
    if (state.step === steps.length - 1) {
      setSubmitted(true);
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    dispatch(
      trademarkRegistrationPreOrder(
        productInfo,
        imageLogo,
        steps.length - 1,
        false
      )
    );
  }
  useEffect(() => {
    if (prevState?.verifying && !state.verifying && suspendedAction) {
      handleNext();
    }
  }, [prevState, state, suspendedAction, handleNext]);

  useEffect(() => {
    if (errors && submitted) {
      setSubmitted(false);
    }
  }, [errors, submitted]);

  if (submitted) {
    return (
      <Box sx={{ width: '100%' }}>
        <Container className="md-container">
          {config.skin !== 'v2-basic' && (
            <>
              <div className="desktop">
                <ProductHeader
                  header="Official"
                  header2="US Trademark Registration"
                />{' '}
              </div>
              <div className="mobile">
                <ProductHeader
                  header="Official"
                  header2="US Trademark Registration"
                />
              </div>
              <ProductStep activeStep={state.step} steps={steps} />
            </>
          )}
          <React.Fragment>
            <Box sx={{ display: 'flex' }}>
              <Spinner animation="border" style={{ margin: 'auto' }} />
            </Box>
          </React.Fragment>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Container className="md-container">
        {config.skin !== 'v2-basic' && state.step === 3 && ''}
        {config.skin !== 'v2-basic' && state.step !== 3 && (
          <>
            <div className="desktop">
              <ProductHeader
                header="Official"
                header2="US Trademark Registration"
              />{' '}
            </div>
            <div className="mobile">
              <ProductHeader
                header="Official"
                header2="US Trademark Registration"
              />
            </div>
            <ProductStep activeStep={state.step} steps={steps} />
          </>
        )}

        {state.step === steps.length ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <Button onClick={handleReset}>Reset</Button>
            </Box>
          </React.Fragment>
        ) : null}
        {state.step === 0 ? (
          <TrademarkStep1
            state={state}
            onChange={handleChange}
            validated={validated}
            imageLogoSrc={imageLogoSrc}
            allowedExtensions={allowedExtensions}
          />
        ) : null}
        {state.step === 1 ? (
          <TrademarkStep2
            state={state}
            onChange={handleChange}
            onBlur={onBlur}
            onHandleCoOwners={onHandleCoOwners}
            validated={validated}
          />
        ) : null}
        {state.step === 2 ? (
          <TrademarkStep3
            state={state}
            validated={validated}
            onHandleCategories={onHandleCategories}
          />
        ) : null}
        {state.step === 3 && process.env.NEXT_PUBLIC_BASE_PATH === '/3' && (
          <TrademarkStep43
            state={state}
            onChange={handleChange}
            validated={validated}
            registerTrademarkList={registerTrademarkList}
          />
        )}
        {state.step === 3 && process.env.NEXT_PUBLIC_BASE_PATH !== '/3' && (
          <TrademarkStep4
            state={state}
            onChange={handleChange}
            validated={validated}
            registerTrademarkList={registerTrademarkList}
          />
        )}
        {/*{state.step === 4 ? (*/}
        {/*  <TrademarkStep5*/}
        {/*    state={state}*/}
        {/*    onChange={handleChange}*/}
        {/*    validated={validated}*/}
        {/*    searchProductList={searchProductList}*/}
        {/*  />*/}
        {/*) : null}*/}
        {state.step === 4 ? (
          <TrademarkStep6
            state={state}
            onChange={handleChange}
            validated={validated}
            trademarkRushProcessing={trademarkRushProcessing}
          />
        ) : null}
        <Error error={errors} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent:
              config.skin === 'v2-basic' ? 'flex-end' : 'flex-start',
            flexWrap: config.skin === 'v2-basic' ? 'wrap' : 'unset',
            pt: 1,
            pb: 1,
          }}
        >
          {config.skin === 'v2-basic' && state.step !== 3 && (
            <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  pt: 1,
                  pb: 1,
                  opacity: 0.9,
                }}
              >
                <Box sx={{ display: 'flex', mr: 1 }}>
                  <img
                    src={`${config.basePath}/images/lock-dark.png`}
                    alt=""
                    layout="fill"
                  />
                </Box>
                <span className="lock-text">
                  Click on "Continue" to save your application
                </span>
              </Box>
            </Box>
          )}

          {state.step !== 0 && (
            <Button
              className="prev"
              disabled={state.step === 0}
              onClick={handleBack}
              onMouseDown={() => setSuspendedAction(true)}
              onTouchStart={() => setSuspendedAction(true)}
              variant="outlined"
              sx={{ mr: 1, mt: 1, mb: 1 }}
              {...(state.step === 3 && { style: { marginRight: '0px' } })}
            >
              Previous
            </Button>
          )}
          {state.step !== 3 ? (
            <Button
              onClick={handleNext}
              onMouseDown={() => setSuspendedAction(true)}
              onTouchStart={() => setSuspendedAction(true)}
              variant="outlined"
              sx={{ mt: 1, mb: 1 }}
            >
              {state.step === steps.length - 1 ? 'Continue' : 'Continue'}
            </Button>
          ) : (
            ''
          )}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
          {state.step < 3 ? (
            <Form.Text className="text-muted" style={{ marginTop: '20px' }}>
              Once you have received your search(es) and our specialists have
              curated your Trademark application, Trademark Genius will collect
              and pay the government Base application (Sections 1 and 44), per
              class filing fee of $350. Our pricing includes a base cost of $450
              per class, which covers the application filing fee and ensures
              that we can process your application thoroughly, even in cases
              where additional information is required.
            </Form.Text>
          ) : (
            ''
          )}
        </Box>
      </Container>
    </Box>
  );
}
